export default {
  title: {
    id: 'product_jp_rakuten_step_title',
    defaultMessage: 'Rakuten point campaign',
  },
  yesLabel: {
    id: 'product_jp_rakuten_step_yes_label',
    defaultMessage: 'Get up to 15,000 pt when transfer',
  },
  yesDescription: {
    id: 'product_jp_rakuten_step_yes_description',
    defaultMessage: 'Up to 12,000 pt if first-time',
  },
  noLabel: {
    id: 'product_jp_rakuten_step_no_label',
    defaultMessage: 'Skip this time',
  },
  guidanceLabel: {
    id: 'product_jp_rakuten_step_guidance_label',

    defaultMessage: 'About campaign',
  },
  guidanceDescription: {
    id: 'product_jp_rakuten_step_guidance_description',
    defaultMessage:
      'Get rewarded with Rakuten Points when you purchase a refurbished smartphone from Back Market and sign up for Rakuten Mobile for the first time or switch your carrier. Don’t miss this chance to save on both your smartphone and mobile plan!',
  },
}
